module.exports = __webpack_public_path__ + "280ee9cfd972a7a06808aad0a26e5992.png";